import $ from 'jquery';
    

    const spinner = {};

    spinner.show = function (parentElement) {
        const $spinner = $(parentElement).find('.spinner');
        $spinner.removeClass('u-hide').addClass('u-show');

    };

    spinner.hide = function (parentElement) {
        const $spinner = $(parentElement).find('.spinner');
        $spinner.removeClass('u-show').addClass('u-hide');
    }

    export default spinner;




// WEBPACK FOOTER //
// ./mobile-core/src/spinner.js